/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const fullDoorBaseComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withEntity('FullDoorBase').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_LYNX_2DDH_PO_FDH_3D_BODY',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'body', true).withEntity('FullDoorBase').attach(memoEval((self)=>[
            self.$width
        ], ($width)=>({
            morphTargetInfluences: {
                Width: {
                    value: $width,
                    scaleZero: 12 * 25.4,
                    scaleOne: 24 * 25.4
                }
            }
        })))
];

//# sourceMappingURL=full-door-base.js.map